/** Fixed-order, lightweight reward game for Shopify OS 2.0. */
(function () {
  'use strict';

  function storageKey(game) { return 'reward-game-completed-' + game.id; }
  function completed(game) {
    try { return Number(window.localStorage.getItem(storageKey(game))) > Date.now(); }
    catch (error) { return false; }
  }
  function remember(game) {
    try {
      var days = Math.max(1, Number(game.dataset.memoryDays) || 7);
      window.localStorage.setItem(storageKey(game), String(Date.now() + days * 86400000));
    } catch (error) { /* The current visit still works when storage is unavailable. */ }
  }
  function setReward(card, reward) {
    var image = card.querySelector('[data-reward-image]');
    var fallback = card.querySelector('[data-reward-fallback]');
    image.alt = reward.title;
    fallback.textContent = reward.title;
    if (!reward.image) { image.classList.add('is-missing'); return; }
    image.src = reward.image;
    image.addEventListener('error', function () { image.classList.add('is-missing'); }, { once: true });
  }
  function confetti(container, amount) {
    var colors = ['#f4ba31', '#54c4ff', '#ffffff', '#157ee4', '#ff8d7e'];
    var fragment = document.createDocumentFragment();
    for (var index = 0; index < amount; index += 1) {
      var piece = document.createElement('i');
      piece.style.setProperty('--x', (Math.random() * 185 - 92) + 'vw');
      piece.style.setProperty('--y', (Math.random() * 100 - 20) + 'vh');
      piece.style.setProperty('--rotate', (Math.random() * 180) + 'deg');
      piece.style.setProperty('--confetti-color', colors[index % colors.length]);
      fragment.appendChild(piece);
    }
    container.replaceChildren(fragment);
    window.setTimeout(function () { container.replaceChildren(); }, 2400);
  }
  function init(game) {
    if (game.dataset.initialized || completed(game)) return;
    game.dataset.initialized = 'true';
    var cards = Array.prototype.slice.call(game.querySelectorAll('[data-reward-card]'));
    var template = game.querySelector('[data-reward-data]');
    var rewards = Array.prototype.slice.call(template.content.querySelectorAll('span')).map(function (item) {
      return { image: item.dataset.image, title: item.dataset.title };
    });
    var progress = game.querySelector('[data-reward-progress]');
    var steps = game.querySelectorAll('.reward-game__steps i');
    var claim = game.querySelector('[data-reward-claim]');
    var confettiBox = game.querySelector('[data-reward-confetti]');
    var opened = 0;
    var messages = ['2 Rewards Left', '1 Reward Left', 'Rewards Unlocked!'];
    var animationOn = game.dataset.animations === 'true';

    game.classList.add('is-active');
    game.setAttribute('aria-hidden', 'false');
    document.body.classList.add('reward-game-lock');
    if (animationOn) game.classList.add('is-animating');

    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        if (opened >= rewards.length || card.classList.contains('is-revealed')) return;
        var reward = rewards[opened];
        setReward(card, reward);
        opened += 1;
        card.classList.add('is-revealed', 'is-revealing');
        card.disabled = true;
        card.setAttribute('aria-label', reward.title + ' revealed');
        steps[opened - 1].classList.add('is-complete');
        progress.textContent = messages[opened - 1];
        window.setTimeout(function () {
          card.classList.remove('is-revealing');
          card.classList.add('is-reveal-complete');
        }, opened === 3 ? 1280 : 720);

        if (animationOn) confetti(confettiBox, opened === 3 ? 44 : 12);
        if (opened === rewards.length) {
          card.classList.add('is-jackpot');
          game.classList.remove('is-animating');
          if (animationOn) game.classList.add('is-jackpot-active');
          window.setTimeout(function () { claim.hidden = false; claim.focus(); }, animationOn ? 1280 : 20);
        }
      });
    });
    claim.addEventListener('click', function () {
      remember(game);
      game.classList.add('is-exiting');
      window.setTimeout(function () { game.classList.remove('is-active'); game.setAttribute('aria-hidden', 'true'); document.body.classList.remove('reward-game-lock'); }, 320);
    });
  }
  function initialiseAll() { document.querySelectorAll('[data-reward-game]').forEach(init); }
  /* This script is placed after the section markup so the overlay can start immediately. */
  initialiseAll();
  document.addEventListener('shopify:section:load', function (event) { var game = event.target.querySelector('[data-reward-game]'); if (game) init(game); });
}());
